const error = (
  state,
  { payload: { failedActionType, canBeRetried, ...rest } }
) => ({
  ...state,
  errors: [
    ...state.errors,
    {
      type: failedActionType,
      canBeRetried,
      payload: rest
    }
  ]
});

export default error;
